// Shared SEO helpers: site origin + head metadata management.

export const SITE_FAVICON =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/14bc629c50c04cb08f38590896596985.jpeg";

export function getSiteUrl(): string {
  const raw = import.meta.env.VITE_SITE_URL || "https://allchinabuyspread.top";
  return raw.replace(/\/+$/, "");
}

function ensureMeta(attr: "name" | "property", key: string): HTMLMetaElement {
  const existing = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (existing) return existing;
  const el = document.createElement("meta");
  el.setAttribute(attr, key);
  document.head.appendChild(el);
  return el;
}

function setMetaContent(attr: "name" | "property", key: string, content?: string) {
  if (!content) {
    const existing = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
    if (existing) existing.remove();
    return;
  }
  ensureMeta(attr, key).setAttribute("content", content);
}

function setLink(rel: string, href?: string) {
  if (!href) {
    const existing = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
    if (existing) existing.remove();
    return;
  }
  let el = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export interface RouteSeoData {
  title: string;
  description: string;
  keywords: string;
  canonical: string;
  ogTitle: string;
  ogDescription: string;
  ogType: string;
  ogImage?: string;
  twitterImage?: string;
  noindex?: boolean;
}

export function applySeo(data: RouteSeoData) {
  document.title = data.title;

  setMetaContent("name", "description", data.description);
  setMetaContent("name", "keywords", data.keywords);
  setMetaContent("name", "robots", data.noindex ? "noindex, nofollow" : "index, follow");

  setLink("canonical", data.canonical);

  setMetaContent("property", "og:title", data.ogTitle);
  setMetaContent("property", "og:description", data.ogDescription);
  setMetaContent("property", "og:url", data.canonical);
  setMetaContent("property", "og:type", data.ogType);
  setMetaContent("property", "og:image", data.ogImage);

  setMetaContent("name", "twitter:title", data.ogTitle);
  setMetaContent("name", "twitter:description", data.ogDescription);
  setMetaContent("name", "twitter:image", data.twitterImage);
}